import React from "react";
import NavBar from "../components/NavBar";
import Title from "../components/Title";
import ObjectiveForm from "../components/forms/ObjectiveForm";
import { ObjectiveText } from "../Text";
import { useParams } from "react-router-dom";
import { useUser } from "../contexts/UserContext";
import { useQuery } from "@apollo/client";
import { GET_ISCOMPLETED_BY_ID } from "../apollo-queries";

const ObjectiveScreen: React.FC = () => {
  const { user } = useUser();
  // pulls the uuid from the URL
  const {uuid} = useParams<{uuid: string}>();
  const userIdString: string = uuid!;

  if (userIdString !== undefined) {
    user.uuid = userIdString;
  }

  const {
    loading: isCompletedLoading,
    error: isCompletedError,
    data: data,
  } = useQuery(GET_ISCOMPLETED_BY_ID, {
    variables: { user_id: user.uuid },
    fetchPolicy: "network-only", // stops apollo from getting data from the cache and instead queries the DB
  });
  if (isCompletedLoading) return <>Loading...</>;
  return (
    <>
      <div className="hidden laptop:block">
        <NavBar
          activePage="Objective"
          completed={data?.users[0].is_completed}
        />
      </div>
      <div className="flex">
        <div className="px-10 text-UDig-gray tablet:px-20 laptop:ml-72 laptop:px-40 w-full flex flex-col">
          <Title
            title={ObjectiveText.title}
            subTitle={ObjectiveText.subTitle}
          />
          <ObjectiveForm />
        </div>
      </div>
    </>
  );
};

export default ObjectiveScreen;
